import { asScaled } from '../utils';
const checkBoxLayout = {
    label: {
        width: 78,
        height: 40,
        minWidth: 78,
        textFontSize: 14,
        iconWidth: 11,
        iconHeight: 10,
        iconFontSize: 9,
        radius: 4,
        wrapperPadding: 12
    },
    base: {
        width: 20,
        height: 20,
        iconWidth: 20,
        iconHeight: 20,
        radius: 0,
        wrapperPadding: 12
    }
};
const checkBoxLayoutScaled = asScaled(checkBoxLayout);
export const checkBox = {
    scaled: checkBoxLayoutScaled,
    unscaled: checkBoxLayout
};
